import type { EventDefinition, ParamsType } from "../types";

type CheckboxFormQuestionAnsweredParams = ParamsType & {
  pageIndex: number;
  pageName: string;
  sectionName: string;
  question: string;
  answer: string[];
};

// Coverage selection events (recommendations, showcase, etc.)
export const coverageSelectionEventDefinitions: EventDefinition[] = [
  {
    name: "checkboxFormQuestionAnswered",
    type: "unstructured",
    makePayload: params => {
      const { context, pageIndex, pageName, sectionName, question, answer } =
        params as CheckboxFormQuestionAnsweredParams;

      return {
        schema:
          "iglu:com.simplybusiness/checkbox_form_question_answered/jsonschema/1-0-1",
        data: {
          site: context.site,
          vertical: context.vertical ?? "",
          journey_id: context.journeyId,
          page_index: pageIndex,
          page_name: pageName,
          section_name: sectionName,
          question,
          answer,
        },
      };
    },
  },
];
